import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AssetTypeResponse} from '../../../../_models/asset-type.model';
import {AssetTypeService} from '../../../../_services/asset-type-service';

@Component({
    selector: 'acabim-admin-update-asset-type',
    templateUrl: './update-asset-type.component.html',
    styleUrls: ['./update-asset-type.component.scss']
})
export class UpdateAssetTypeComponent implements OnInit, OnDestroy {

    @Output() completed = new EventEmitter<string>();
    @Input() public assetTypeDetails: AssetTypeResponse | null = null;
    loading = false;
    assetTypeForm: FormGroup | undefined;
    currentAsset: AssetTypeResponse | null = null;
    private _doSubmit = true;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private readonly messageService: MessageService,
        private assetTypeService: AssetTypeService,
        private confirmationService: ConfirmationService
    ) {
    }

    ngOnInit(): void {
        if (this.assetTypeDetails !== null && this.assetTypeDetails.id !== null) {
            this._currentProcess = this.assetTypeService.getAssetType(this.assetTypeDetails.id).subscribe(
                ct => {
                    this.currentAsset = ct;
                    this.initForm();
                }
            );
        }
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }

    private initForm(): void {
        if (this.currentAsset != null) {
            this.assetTypeForm = new FormGroup({
                name: new FormControl(this.currentAsset.name, Validators.required),
                description: new FormControl(this.currentAsset.description)
            });
        }
    }

    onAssetTypeUpdateSubmit(): void {
        this.loading = true;
        if (typeof this.assetTypeForm !== 'undefined') {
            if (this._doSubmit) {
                this.upsertAssetType();
            }
        }
    }

    onAssetTypeDeleteSubmit(): void {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.onAssetTypeDeleteConfirmed();
            },
            reject: () => {
                this.onRejectDeletion();
            }
        });
    }

    onRejectDeletion(): void {
        this.messageService.clear('assetTypeConfirmDeletion');
    }

    onAssetTypeDeleteConfirmed(): void {
        this.loading = true;
        if (this.assetTypeForm) {
            if (this._doSubmit && this.currentAsset) {
                this._currentProcess = this.assetTypeService.deleteAssetType(this.currentAsset.id).subscribe(
                    result => {
                        console.log(result);
                        this.completed.emit('deleted');
                        this.loading = false;
                    }
                );
                this.upsertAssetType();
            }
        }
    }

    private upsertAssetType(): void {
        if (this.assetTypeForm && this.currentAsset) {

            this.logger.debug('[UpdateAssetTypeComponent] Updating existing asset type');
            this._currentProcess = this.assetTypeService.upsertAssetType(
                this.assetTypeForm.value.name,
                this.assetTypeForm.value.description,
                this.currentAsset.id.toString()
            ).subscribe(newAssetType => {
                this.logger.debug('[UpdateAssetTypeComponent] Asset type updated successfully: ', newAssetType.id);
                this.initForm();
                this.completed.emit('updated');
                this.loading = false;
                console.log('Upsert: updated');
            }, (error: any) => {
                this.logger.debug('[UpdateAssetTypeComponent] Asset type failed to update');
                this.logger.error(error);
                this.loading = false;
            });
        }
    }

    onCancel(): void {
        this.logger.debug('[UpdateAssetTypeComponent] Update asset type modal Cancelled');
        console.log('Upsert: cancelling');
        this.completed.emit('cancelled');
    }
}
